import { useQuery } from '@tanstack/react-query';
import { getDmPatient, type DmPatient } from '../services/dmPatient';

export function dmPatientQueryKey(patientId: string | undefined) {
    return ['v2/patients', patientId, 'dm', 'patient'];
}

export function useDmPatient(patientId: string | undefined) {
    const { data, error, isLoading, refetch } = useQuery<DmPatient | null>({
        queryKey: dmPatientQueryKey(patientId),
        queryFn: () => getDmPatient(patientId!),
        enabled: !!patientId,
        staleTime: 2 * 60 * 1000
    });

    return { data: data ?? null, isLoading, error, refetch };
}
